import React from 'react';
import { FilledInput, FormControl, InputLabel, MenuItem, Select } from 'housecall-ui';

import { PricingFormOptionType } from '../../types/types';

type Props = {
  options: PricingFormOptionType[];
  label: string;
  value: string;
  onChange: (value: number) => void;
};

export const PricingFormSingleSelect = ({ value, onChange, options, label }: Props) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onSelect = (event: React.ChangeEvent<{ name?: string; value: any }>) => {
    onChange(event?.target.value);
  };

  return (
    <FormControl fullWidth variant="filled">
      <InputLabel>Options</InputLabel>
      <Select
        data-testid="pricing-form-single-select"
        fullWidth
        onChange={onSelect}
        value={value}
        input={<FilledInput fullWidth name={label} />}
      >
        {options.map((option: PricingFormOptionType) => (
          <MenuItem key={option.id} data-testid={`menu-item-${option.id}`} value={option.id}>
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
